import { buildRecordTargetSchema } from "features/Resources/Shared/Components/Form/RecordTargetForm/schema";
import * as yup from "yup";
import { pathSchema } from "features/Path/schema";
import { trigger } from "features/Trigger/TemplateTrigger/Form/schema";

export const messageTemplateSchema = yup.object({
  pathIds: yup.array().of(yup.string().required()).optional().default([]),
  paths: yup.array().of(pathSchema).optional().default([]),
  name: yup.string().required().label("Title").max(70, "Title cannot be more than 70 characters"),
  recipient: buildRecordTargetSchema("Recipient", true),
  senderId: yup.string().nullable().optional().label("Sender"),
  deliverAtTrigger: trigger.required().label("Send At"),
  body: yup.string().required().label("Body"),
  allowWeekends: yup.boolean().optional().default(false).label("Allow Weekends"),
});

export type MessageTemplateSchema = yup.InferType<typeof messageTemplateSchema>;

/**
 * NOTE: This schema type may include form-specific fields (like 'paths') that aren't sent to the API.
 * Use toCreateMessageTemplatePayload() or toUpdateMessageTemplatePayload() from ./helpers
 * to transform form data into the correct API payload structure.
 */
